import {
	DestroyRef,
	Directive,
	inject,
	input,
	signal,
	TemplateRef,
	ViewContainerRef,
} from '@angular/core';
import { DrawerService, type DrawerConfig, type DrawerPlacement, type DrawerRef } from './drawer.service';

@Directive({
	selector: '[sklDrawer]',
	exportAs: 'sklDrawer',
})
export class DrawerDirective {
	readonly #drawerService = inject(DrawerService);
	readonly #templateRef = inject(TemplateRef<unknown>);
	readonly #viewContainerRef = inject(ViewContainerRef);
	readonly #destroyRef = inject(DestroyRef);

	readonly drawerPlacement = input<DrawerPlacement>('right');
	readonly drawerLightDismiss = input<boolean>(true);
	readonly drawerBackdrop = input<boolean>(false);
	readonly drawerCanResize = input<boolean>(false);
	readonly drawerWidth = input<string | undefined>();

	readonly isOpen = signal(false);

	#drawerRef: DrawerRef | null = null;

	constructor() {
		this.#destroyRef.onDestroy(() => this.close());
	}

	public open() {
		if (this.#drawerRef) return;

		const config = {
			placement: this.drawerPlacement(),
			lightDismiss: this.drawerLightDismiss(),
			backdrop: this.drawerBackdrop(),
			canResize: this.drawerCanResize(),
			width: this.drawerWidth(),
		} satisfies DrawerConfig;

		this.#drawerRef = this.#drawerService.create(
			this.#templateRef,
			config,
			this.#viewContainerRef,
			() => {
				this.#drawerRef = null;
				this.isOpen.set(false);
			},
		);

		this.isOpen.set(true);
	}

	public close() {
		if (!this.#drawerRef) return;

		this.#drawerRef.close();
	}

	public toggle() {
		this.isOpen() ? this.close() : this.open();
	}
}
